<template>
  <div class="protocols">

    <div class="row pager-btn-row mb-5 mb-md-2" v-if="!isMensurationForbidden">

      <div class="col-md-12 col-lg-12 text-right">
        <router-link class="btn btn-primary" :to="{ name: 'protocol-create'}"
                     :disabled="disabled">
          {{'protocol.buttons.create' | trans}}
        </router-link>
      </div>
    </div>

    <table-view
        :options="options"
        :isLoaded=isLoaded
        :isList=isMobile
        :isChange="isChange"
        :isTwoSearch=true
        v-on:on-search="onSearchEnter"
        v-on:on-search-skill-field="onSearchSkillField"
    >

        <div slot="id" slot-scope="props">
          <div class="icon-circle icon-blue">
            <span v-if="!isMobile">{{'user.P' | trans}}</span>
          </div>
        </div>

        <div slot="title" slot-scope="props">

          <strong>{{props.row.title}}</strong><br>

          <div>
            <dl class="term_with_descr">
              <dt>{{'protocol.protocol_goal' | trans}}:</dt>
              <dd>{{props.row.goal}}</dd>
            </dl>
          </div>
          <div>
            <dl class="term_with_descr">
              <dt>{{'protocol.area' | trans}}:</dt>
              <dd>{{props.row.skillField.name}}</dd>
            </dl>
          </div>
          <div v-if="props.row.draft && !isMensurationForbidden">
            <span>{{'protocol.unsaved_changes' | trans}}:</span>
            <router-link :to="{ name: 'protocol-edit', params: { protocolId: props.row.draft.id}}">
              {{'protocol.view_auto_save' | trans}}
            </router-link>
          </div>
        </div>

        <div slot="createdAt" slot-scope="props">
          {{props.row.createdAt.date | toLocaleDate}}
        </div>

        <span slot="published" slot-scope="props"
              v-if="!props.row.published">{{'protocol.notPublish' | trans}}</span>

        <mdc-menu-anchor slot="action" slot-scope="props">
          <mdc-button raised @click="props.row.isOpen=true">
            <i class="material-icons">more_vert</i></mdc-button>
          <mdc-menu v-model="props.row.isOpen">
            <mdc-menu-item v-if="!isMensurationForbidden">
              <router-link class="nav-link"
                           :to="{ name: 'protocol-edit', params: { protocolId: props.row.id }}">
                {{'protocol.buttons.edit' | trans}}
              </router-link>
            </mdc-menu-item>
            <mdc-menu-item v-if="!isMensurationForbidden">
              <a href="#" class="nav-link" @click.prevent="duplicateProtocol(props.row.id)">{{'protocol.buttons.duplicate'
                | trans}}</a>
            </mdc-menu-item>
            <mdc-menu-item v-if="!isMensurationForbidden">
              <a href="#" class="nav-link" @click.prevent="showDeletePopup(props.row.id)">{{'protocol.buttons.delete'
                | trans}}</a>
            </mdc-menu-item>
            <mdc-menu-item>
              <a href="" class="nav-link"
                 @click.prevent="exportProtocol(props.row.id)">{{'protocol.buttons.export'
                | trans}}</a>
            </mdc-menu-item>
          </mdc-menu>
        </mdc-menu-anchor>

        <div slot="mobileTitle">
          {{'protocol.protocols' | trans}}
        </div>

      <div slot="mobileHeader" slot-scope="props">
          <div class="icon-circle icon-blue"></div>
          <b>{{props.row.title}}</b>
      </div>


    </table-view>

    <div class="row pager-btn-row">

      <div class="col-md-12 col-lg-12 text-right" v-if="!isMensurationForbidden">
        <router-link class="btn btn-primary" :to="{ name: 'protocol-create'}"
                     :disabled="disabled">
          {{'protocol.buttons.create' | trans}}
        </router-link>
      </div>
    </div>

    <mdc-dialog v-model="isModalVisible"
                :title="'user.confirm_delete' | trans"
                :accept="'user.delete' | trans"
                :cancel="'user.cancel' | trans"
                @accept="deleteProtocol(protocolId)"
                @cancel="onModalClose">

    </mdc-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import isEmpty from 'lodash/isEmpty';
  import Paginate from 'vuejs-paginate';
  import Loader from '../../loader/components/Loader';
  import TableView from '../../../common/table/components/TableView';
  import {mapGetters} from 'vuex';

  export default {
    data() {
      return {
        isChange: false,
        apiUrl: '/protocols/',
        protocols: [],
        paginate: {
          perPage: 5,
          page: 1,
          forcePage: 0,
          lastPage: null,
          pageRange: 3,
          marginPages: 2,
        },
        disabled: false,
        isLoaded: true,
        isModalVisible: false,
        protocolId: null,
        options: {
          pageHeader: 'protocols',
          initialPage: null,
          filterable: false,
          sortable: [],
          debounce: 1000,
          skin: 'table table-sm',
          withSearch: true,
          columns: [
            {
              key: 'id',
              changed: true,
              headings: lang.get('protocol.protocols')
            },
            {
              key: 'title',
              changed: true,
              headings: ''
            },
            {
              key: 'published',
              changed: true,
              headings: ''
            },
            {
              key: 'createdAt',
              changed: true,
              headings:  lang.get('protocol.create_date')
            },
            {
              key: 'action',
              changed: true,
              headings: ''
            }
          ],
          listRow: {
            goal:
              {
                headings: lang.get('protocol.protocol_goal'),
                hasTemplate: false,
              },
            createdAt:
              {
                headings: lang.get('protocol.create_date'),
                hasTemplate: false,
              },
          },
          headings: {goal: lang.get('protocol.protocols')},
          dateColumns:['created_at'],
          texts:{
            filterPlaceholder: lang.get('bids.type_the_procol_name_to_search'),
            noResults:lang.get('protocol.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          columnsClasses:{
            id:'icons-field',
            action:'table-actions',
            title: 'wide-col',
            published: 'nowrap',
            createdAt: 'nowrap'
          },
          search: '',
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          }
        },

      };
    },

    components: {
      Paginate, Loader,TableView
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
        'isMensurationForbidden',
      ]),
      isEmptyProtocols: function() {
        return isEmpty(this.protocols);
      },
    },

    created() {
      if (this.isMobile){
        //this.fetchProtocols(this.paginate.perPage, this.paginate.page);
      }
    },

    methods: {
      async requestFunction (data) {
        return this.fetchProtocols(data.limit, data.page, data.query)
      },
      fetchProtocols: async function(perPage, page, search) {
        try {
          this.isLoaded = false;
          //search = search ? search : this.search;
          localStorage.setItem('currentPage', page);
          localStorage.setItem('currentPageHeader', 'protocols');
          let params = {
            sort: this.sort,
            search: search ? search.search : this.search,
            searchSkillField: search ? search.searchSkillField : this.searchSkillField
          };
          let url = this.apiUrl + perPage + '/' + page;

          let response = await axios.get(url, {params: params});

          let protocols = response.data.data.items;
          protocols.forEach(function(item) {
            item.isOpen = false;
          });
          this.protocols = protocols;
          this.setPaginate(response.data.data);
          this.isLoaded = true;
          this.isChange = false;
          return response
        } catch (error) {
          console.dir(error);
          if (error.status == 403) {
            this.$router.push({name: 'client'});
          }
        }
      },

      showDeletePopup(id) {
        this.protocolId = id;
        this.isModalVisible = true;
      },

      async duplicateProtocol(protocolId){
        try {
          this.isLoaded = false;

          let response = await axios.post(this.apiUrl + protocolId + '/copy' );
          this.isChange = true;
          return response.data.data;

          this.isLoaded = true;
        } catch (error) {
          console.dir(error);
        }
      },

      onModalClose() {
        this.isModalVisible = false;
      },

      setPaginate: function(data) {
        this.paginate.perPage = data.perPage;
        this.paginate.page = data.currentPage;
        this.paginate.lastPage = data.lastPage;
      },

      detectProtocol: async function(protocolId) {
        let response = await axios.get(this.apiUrl + protocolId + '/teaching-method' );
        return response.data.data.id;
      },

      deleteProtocol: async function(id) {
        try {
          this.isLoaded = false;
          let index = findIndex(this.protocols, function(protocol) {
            return protocol.id === id;
          });
          let teachingMethodId = await this.detectProtocol(id);

          let url = teachingMethodId == 3 ? this.apiUrl + 'mand/' : this.apiUrl;

          if (index !== -1) {

            let response = await axios.delete(url + id);
            this.protocols.splice(index, 1);
            this.isChange = true;
            this.paginate.forcePage = (this.paginate.page - 1);
            if (this.protocols.length === 0 && ((this.paginate.page - 1) > 0)) {
              this.paginate.page = this.paginate.page - 1;
              this.fetchProtocols(this.paginate.perPage, this.paginate.page);
            }
          }
          this.isLoaded = true;
        } catch (error) {
          console.dir(error);
        }
      },

      exportProtocol: async function(id) {
        try {
          let response = await axios.get(this.apiUrl + 'pdf/' + id,
              {responseType: 'blob'}).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', lang.get('protocol.protocol') + '_' + id + '.pdf');
            document.body.appendChild(link);
            link.click();
          });
        } catch (error) {
          console.dir(error);
        }
      },

      onPaginationClick: async function(pageNum) {
        this.fetchProtocols(this.paginate.perPage, pageNum);
        this.paginate.page = pageNum;
        this.paginate.forcePage = pageNum - 1;
      },
      onSearchEnter: function (search) {
        this.search = search;
        this.paginate.page = 1;
      },
      onSearchSkillField: function (searchSkillField) {
        this.searchSkillField = searchSkillField;
        this.paginate.page = 1;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/ProtocolList.vue